import React from "react";

const ContractTabs = ({ activeTab, setActiveTab, selectedTab }) => {
  const TAB_CONFIG = {
    all: [
      { key: "all", label: "All Data Contracts" },
    ],
    assets: [
      { key: "all", label: "All Assets" },
      { key: "mySubscriptions", label: "My Subscriptions" },
      { key: "myContracts", label: "My Assets" },
    ],
    report: [
      { key: "all", label: "Solution Catalogue" },
      { key: "reports", label: "My Reports" },
    ],
      glossary: [],
    CUSTOM_TAB: []
  };

  const tabs = TAB_CONFIG[selectedTab] || TAB_CONFIG.all;

  return (
    <div className="card-tabs">
      <nav className="tabs">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`tab ${activeTab === tab.key ? "active-tab" : ""}`}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default ContractTabs;